/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { withLocalization, Text } from 'hocs/localization'
import HomeLayout from 'apps/HomeLayout'
import AuthPage from 'apps/AuthPage'
import LoginForm from 'apps/Profile/LoginForm'

interface IProps {
  t: Text,
}

const Login: React.SFC<IProps> = ({ t }) => (
  <HomeLayout>
    <AuthPage>
       <LoginForm />
    </AuthPage>
  </HomeLayout>
)

export default withLocalization('auth.login')(Login)
